import React from 'react';

const Loading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
      <div className="text-2xl font-bold text-gray-600 dark:text-gray-300">Loading...</div>
    </div>
  );
};

export default Loading;